module.exports = __webpack_public_path__ + "static/media/twitter.737f3566.png";